import React, { useState } from 'react'
import * as THREE from "three"
import useStore from '../StateStore/store'
import {playerOffset} from "../Hall/Stalls/playerOffset"

Array.prototype.equals = function (array) {
    if (!array)
        return false;

    if (this.length != array.length)
        return false;

    for (var i = 0, l=this.length; i < l; i++) {
        if (this[i] instanceof Array && array[i] instanceof Array) {
            if (!this[i].equals(array[i]))
                return false;       
        }           
        else if (this[i] != array[i]) { 
            return false;   
        }           
    }       
    return true;
}

const StallNavigation = () => {

    const [hidden, setHidden] = useState(true)

    const stallPositionState = useStore(state => state.stallPosition) 
    const data = useStore(state => state.stallPosition.stallsData) 
    const dataSet = useStore(state => state.stallPosition.setData) 
    const navState = useStore(state => state.stallPosition.stallNav)
    const setNavState = useStore(state => state.stallPosition.setNav)
    const propogate = useStore((state) => state.propogateToStall.propogateTo)
    const propogation = useStore(state => state.propogateToStall)
    

    // const currentStall = React.useMemo(() => {
    //     if(navState !== false){
    //         return new THREE.Vector3(navState.stallPosition[0]/34, 5, navState.stallPosition[1]/30)
    //     }
    // }, [navState])

    const currentStall = navState !== false ? {[navState.type] : [navState.stallPosition[0]/34, 5, navState.stallPosition[1]/30]} : undefined
    
    const stallData = React.useMemo(() => {
        if(data){
            const typeArray = Object.keys(data)
            const dataArray = Object.values(data)
            const dummyArr = []
            dataArray.forEach((stallData, index) => {
                stallData.pos.forEach((position, i) => {
                    const j = stallData.index[i]
                    const dummyObj = {
                        [typeArray[index]] : position
                    }
                    dummyArr[j] = dummyObj
                })
            })

            return dummyArr
        }
    }, [navState])

    // console.log(stallData)

    const next = React.useCallback(e => {
        if(stallData){

            const i = function(){
                for (let index = 0; index < stallData.length; index++) {
                    const stall = stallData[index];
                    if(JSON.stringify(stall) === JSON.stringify(currentStall)){
                        return index
                    }
                }
            }  
    
            const nextStallPosition = i()+1 >= stallData.length ? Object.values(stallData[0])[0] : Object.values(stallData[i()+1])[0]
            const stallType = i()+1 >= stallData.length ? Object.keys(stallData[0])[0] : Object.keys(stallData[i()+1])[0]
            // console.log(i()+1)
            const offset = playerOffset[stallType]
            const side = nextStallPosition[2] > 0 ? 1: -1
    
            const newPosition = [(nextStallPosition[0]*1.02)+(offset.x*side), 5, (nextStallPosition[2]*0.9)+(offset.z*side)]
    
            propogate(new THREE.Vector3(newPosition[0], 5, newPosition[2]))
            propogation.setPlayerState(true, false)
            setTimeout(() => {
                propogation.setPlayerState(false, false)
            }, 1900);
        }

    }, [navState])

    const prev = React.useCallback(e => {
        if(stallData){
            const i = function(){
                for (let index = 0; index < stallData.length; index++) {
                    const stall = stallData[index];
                    if(JSON.stringify(stall) === JSON.stringify(currentStall)){
                        return index
                    }
                }
            }  
    
            const nextStallPosition = i()-1 <= 0? Object.values(stallData[stallData.length-1])[0] : Object.values(stallData[i()-1])[0]
            const stallType = i()-1 <= 0? Object.keys(stallData[stallData.length-1])[0] : Object.keys(stallData[i()-1])[0]
            // console.log(i()+1)
            const offset = playerOffset[stallType]
            const side = nextStallPosition[2] > 0 ? 1: -1
    
            const newPosition = [(nextStallPosition[0]*1.02)+(offset.x*side), 5, (nextStallPosition[2]*0.9)+(offset.z*side)]
    
            propogate(new THREE.Vector3(newPosition[0], 5, newPosition[2]))
            propogation.setPlayerState(true, false)
            setTimeout(() => {
                propogation.setPlayerState(false, false)
            }, 1900);
        }
    }, [navState])

    // const currentStall = React.useMemo(() => new THREE.Vector3(navState.stallPosition[0]/34, 5, navState.stallPosition[1]/30), [navState])

    


    return (
        <>
            {navState !== false ? (
                <div id = "stall-nav">
                    <button onClick={prev} >Prev</button>
                    <button onClick={next} >Next</button>
                </div>
            ) : null}
        </>
    )
}

export default StallNavigation
